// Single source of the Hitz coordinates of this title. Everything else imports from here.
// Keep in sync with package.json, config/game.json and hitz-contract (npm run release-check).
export const GAME_ID = 'tacada-limpa'
export const GAME_VERSION = '0.1.0'
export const RULES_VERSION = 'tacada-limpa-v1'
/**
 * Official Corp family: 'infinite' (infinite-games) | 'finite' (finite-games) | 'level' (level-games).
 * Difficulty is not a family: independent difficulties are an organization of a finite title (contract `organization`).
 */
export const FAMILY = 'finite'
/** Authorizable scenarios. Level titles whose progress is the platform's use ['next'] (the host answers the numeric level). */
export const LEVEL_IDS = ['1', '2', '3']
/** Terminal `boardState.status` of a normal completion: 'won' (finite, level) or 'game_over' (infinite). Technical constant of the build, not a Corp field. */
export const COMPLETED_STATUS = 'won'
